import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const getListDetailsCatalogo = (query) => http.get(`${api}/compras-catalogo/list-details-catalogo`, { params: { ...query } })

export {
  getListDetailsCatalogo
}
